import { render, staticRenderFns } from "./PhraseBlock.vue?vue&type=template&id=7e2075c2&scoped=true"
var script = {}
import style0 from "./PhraseBlock.vue?vue&type=style&index=0&id=7e2075c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2075c2",
  null
  
)

export default component.exports